var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#04D704",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 23.001H12.8887C13.4789 23.001 14.0555 23.5593 14.0557 24.375V28.125C14.0557 28.9409 13.479 29.5 12.8887 29.5H10.667C10.0767 29.5 9.5 28.9409 9.5 28.125V24.375C9.5002 23.5593 10.0768 23.001 10.667 23.001ZM17.8887 20.501H20.1113C20.7015 20.5011 21.2773 21.0602 21.2773 21.876V28.125C21.2773 28.9408 20.7015 29.4999 20.1113 29.5H17.8887C17.2985 29.4999 16.7227 28.9408 16.7227 28.125V21.876C16.7227 21.0602 17.2985 20.5011 17.8887 20.501ZM25.1113 25.5H27.333C27.9232 25.5 28.4999 26.0592 28.5 26.875V28.125C28.5 28.9409 27.9233 29.5 27.333 29.5H25.1113C24.521 29.5 23.9443 28.9409 23.9443 28.125V26.875C23.9444 26.0592 24.5211 25.5 25.1113 25.5ZM19.7158 12.3154L19.8467 12.6143H20.1338L21.8076 12.8838L20.5283 14.2715L20.3652 14.4482L20.4014 14.6865L20.6914 16.5811L19.2607 15.7383L19.0059 15.5879L18.751 15.7393L17.3105 16.5957L17.6016 14.7021L17.6377 14.4658L17.4766 14.2891L16.1943 12.8838L17.9062 12.6084L18.1748 12.5645L18.2842 12.3154L19 10.6836L19.7158 12.3154Z",
    stroke: "#2C7EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.841507c09fc68ce68fedb8037bbd6379.svg";
export { ForwardRef as ReactComponent };